/* ============
 * Locale
 * ============
 *
 * For a multilanguage application, you can
 * specify the languages you want to use here.
 */

import en from './en'

export default {
  en,
}


// WEBPACK FOOTER //
// ./src/locale/index.js